import React from "react";

const ArchiveTab = (props) =>{
    return(<>Archive board list here</>);
};

export default ArchiveTab;